"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../hooks");
var _utils = require("../utils");
var _Ring = _interopRequireDefault(require("./Ring"));
var _helperComponents = require("./helperComponents");
var _interfaces = require("./interfaces");
var _propTypes = require("./propTypes");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Radio = /*#__PURE__*/(0, _react.forwardRef)((_ref, externalRef) => {
  let {
    colorScheme = _interfaces.RadioColorScheme.Default,
    disabled,
    error,
    ...props
  } = _ref;
  const scopedThemeProps = (0, _hooks.useScopedThemeProps)({
    isInvertedColorScheme: colorScheme === _interfaces.RadioColorScheme.Inverted
  });
  const inputDataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilRadioInput'
  });
  return (0, _react2.jsx)(_helperComponents.RadioOuter, (0, _extends2.default)({}, scopedThemeProps, {
    disabled: disabled
  }, (0, _utils.pickDataTestProps)(props)), (0, _react2.jsx)(_helperComponents.RadioHidden, (0, _extends2.default)({}, inputDataTestProps, (0, _utils.omitDataTestProps)(props), {
    className: "stencilRadioHidden",
    disabled: disabled,
    type: "radio",
    ref: externalRef
  })), (0, _react2.jsx)(_Ring.default, {
    disabled: disabled,
    error: error
  }));
});
var _default = exports.default = (0, _utils.composeStencilComponent)({
  baseComponent: Radio,
  description: 'Form element for choosing one item from a set of options.',
  displayName: 'Radio',
  propTypes: _propTypes.radioPropTypes
});